export class ListSaasEntitiesRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SaasEntityTypeFilters",
            "format": ""
        },
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "SaasEntityExternalIdFilters",
            "format": ""
        },
        {
            "name": "_protected",
            "baseName": "protected",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
